import { adminPath, type AdminClient } from '../core/index.js'
import type { ShiftOutcome } from './types.js'

/** The partner module's admin calls: what partners have reported about a worker of any client, read-only. */
export interface PartnerAdminApi {
  /** Reported shift outcomes, most recent first. */
  workerOutcomes(clientId: string, workerId: string): Promise<ShiftOutcome[]>
}

export function createPartnerAdminApi(client: AdminClient): PartnerAdminApi {
  return {
    workerOutcomes: (clientId, workerId) => client.call('GET', `${adminPath.worker(clientId, workerId)}/outcomes`),
  }
}
